import { FC, useCallback, useEffect, useMemo } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Banner } from '@/_shared/components/Banner';
import { openTabForAsyncRedirect } from '@/_shared/helpers/openTabForAsyncRedirect';
import { useLayoutBanner } from '@/_shared/hooks/useLayoutBanner';
import { getBillingLinkCall } from '@/billing/state/api/getBillingLinkCall';
import { getUserWarningsCall } from '@/core/state/api/getUserWarningsCall';

const BANNER_KEY = 'banner.paymentFailed';

export const PaymentFailedBanner: FC = () => {
  const t = useTranslations('billing.paymentFailedBanner');
  const { setBanner } = useLayoutBanner();
  const { isPaymentFailed } = getUserWarningsCall.hook();
  const { execute: executeGetBillingLink } = getBillingLinkCall.hook();

  const onCtaClick = useCallback(() => {
    const { redirect, close } = openTabForAsyncRedirect();

    executeGetBillingLink({
      successSaga: ({ response }) => {
        if (response?.link) {
          redirect(response.link);
        } else {
          close();
        }
      },
      errorSaga: () => {
        close();
      },
    });
  }, [executeGetBillingLink]);

  const cta = useMemo(
    () => ({
      label: t('cta'),
      onClick: onCtaClick,
    }),
    [t, onCtaClick],
  );

  useEffect(() => {
    if (!isPaymentFailed) {
      setBanner(BANNER_KEY, null);
      return;
    }

    setBanner(
      BANNER_KEY,
      <Banner message={t('message')} cta={cta} type='error' iconName='lightBulb' hideCloseButton />,
    );
  }, [isPaymentFailed, cta, t, setBanner]);

  return null;
};
